import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  OnInit,
} from '@angular/core';
import { User } from '../../models/user';
import { UserApiService } from '../../services/api/user.api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DetailViewInputComponent } from '../detail-view-input/detail-view-input.component';
import { ErrorHandlingService } from 'src/app/services/error-handling.service';
import { GoogleAnalyticsService } from '~services/google-analytics.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

interface FormValue {
  name: string;
  phone: string;
  pin: number;
}

@Component({
  selector: 'sa-driver-profile-detail-view',
  templateUrl: './driver-profile-detail-view.component.html',
  styleUrls: ['./user-detail-view.component.scss'],
})
export class DriverProfileDetailViewComponent implements OnInit {
  public formGroup: FormGroup;
  @Input() user: User;
  @Output() onUserUpdated: EventEmitter<User> = new EventEmitter<User>();
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  buttonDisabled = false;

  @ViewChildren('detailInput') inputs: QueryList<DetailViewInputComponent>;

  constructor(
    private userApiService: UserApiService,
    private snackBar: MatSnackBar,
    private errorHandler: ErrorHandlingService,
    private gaService: GoogleAnalyticsService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.formGroup = this.fb.group({
      name: [this.user ? this.user.name : null, [Validators.required]],
      phone: [this.user ? this.user.phone : null, [Validators.required]],
      pin: [this.user ? this.user.pin : null, Validators.required],
      cdl: [this.user ? this.user.cdl : null],
    });
  }

  updateDriver(): void {
    if (this.formGroup.invalid) {
      return;
    }
    const formValue: FormValue = this.formGroup.value;
    const updatedUser = Object.assign({}, this.user, formValue);

    if (this.user.id) {
      this.userApiService.updateUser(this.user.id, updatedUser).subscribe(
        (user) => {
          this.user = user;
          this.onUserUpdated.emit(user);
          this.snackBar.open('User successfully updated', null, {
            duration: 2000,
          });
        },
        (err) => {
          err = this.checkForExistingDriver(err);
          this.errorHandler.showError(err);
        },
      );
    }
  }

  removeDriver(id: number): void {
    if (confirm('Are you sure you want to remove this driver?')) {
      this.userApiService.removeDriver(id).subscribe(
        () => {
          this.onUserUpdated.emit(null);
          this.snackBar.open('Driver successfully removed', null, {
            duration: 2000,
          });
        },
        (err) => {
          this.errorHandler.showError(err);
        },
      );
    }
  }

  inviteDriver(): void {
    if (this.formGroup.invalid) {
      return;
    }
    const formValue: FormValue = this.formGroup.value;
    this.buttonDisabled = true;
    this.userApiService.createDriver(formValue).subscribe(
      (user) => {
        this.user = user;
        this.onUserUpdated.emit(user);
        this.buttonDisabled = false;
        this.snackBar.open('Driver successfully invited', null, {
          duration: 2000,
        });
        this.gaService.event('add_driver_manually', {});
      },
      (err) => {
        err = this.checkForExistingDriver(err);
        this.buttonDisabled = false;
        this.errorHandler.showError(err);
      },
    );
  }

  checkForExistingDriver(err: any) {
    return err && err.error && err.error.Message === 'User already created with same role'
      ? 'Driver exists in GoHawk. Dispatch a driver on a load top add him to your driver list'
      : err;
  }

  closeClicked() {
    this.onClose.emit();
  }
}
